import { ParsedToken, User } from "firebase/auth";
import React, { createContext, useMemo, useReducer } from "react";
import { Actions } from "./types";
import { reducer } from "./materialReducer";
import { responseType } from "../../../../../../utils/formTypes";

export interface itmType extends responseType {
  code: string;
}

export interface itmDetailsType extends responseType {
  itemName: string;
  poleNum: number;
  address?: string;
}
export type MaterialStatesType = {
  itm: itmType | null;
  selectedSuppliers: responseType[];
};

export const initialState: MaterialStatesType = {
  itm: null,
  selectedSuppliers: [],
};

const AppContext = createContext<{
  state: MaterialStatesType;
  dispatch: React.Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
interface Props {
  children: React.ReactNode;
}
const AppProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { AppProvider, AppContext };
